import React, { useState, useEffect } from 'react';
import '../CSS/Countdown.css';
import { getEvents, getNextEvent } from '../utils/calendarService';

function Countdown({ targetDate: propTargetDate, eventName: propEventName }) {
  const [targetDate, setTargetDate] = useState(null);
  const [eventName, setEventName] = useState(propEventName || "");
  const [loading, setLoading] = useState(true);

  const [timeLeft, setTimeLeft] = useState({
    days: '00',
    hours: '00',
    minutes: '00',
    seconds: '00',
  });

  // Resolve target date and event name
  useEffect(() => {
    if (propTargetDate) {
      setTargetDate(new Date(propTargetDate));
      setEventName(propEventName || "SLAY TIME");
      setLoading(false);
    } else {
      getEvents().then(events => {
        const next = getNextEvent(events);
        if (next) {
          setTargetDate(next.start);
          const name = next.description
            ? `${next.title} (${next.description})`
            : next.title;
          setEventName(name.toUpperCase());
        } else {
          setTargetDate(null);
          setEventName("NEXT EVENT");
        }
        setLoading(false);
      });
    }
  }, [propTargetDate, propEventName]);

  useEffect(() => {
    if (!targetDate) {
      setTimeLeft({ days: '00', hours: '00', minutes: '00', seconds: '00' });
      return;
    }

    const interval = setInterval(() => {
      const now = new Date();
      const difference = targetDate - now;

      if (difference <= 0) {
        setTimeLeft({ days: '00', hours: '00', minutes: '00', seconds: '00' });
        clearInterval(interval);
        return;
      }

      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);

      setTimeLeft({
        days: String(days).padStart(2, '0'),
        hours: String(hours).padStart(2, '0'),
        minutes: String(minutes).padStart(2, '0'),
        seconds: String(seconds).padStart(2, '0'),
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [targetDate]);

  if (loading) {
    return (
      <div className="countdown-container loading">
        <div className="countdown-text">LOADING NEXT EVENT...</div>
      </div>
    );
  }

  return (
    <div className="countdown-container">
      <div className="countdown-item">
        <div className="countdown-value">{timeLeft.days}</div>
        <div className="countdown-label">days</div>
      </div>
      <div className="colon">:</div>
      <div className="countdown-item">
        <div className="countdown-value">{timeLeft.hours}</div>
        <div className="countdown-label">hours</div>
      </div>
      <div className="colon">:</div>
      <div className="countdown-item">
        <div className="countdown-value">{timeLeft.minutes}</div>
        <div className="countdown-label">minutes</div>
      </div>
      <div className="colon">:</div>
      <div className="countdown-item">
        <div className="countdown-value">{timeLeft.seconds}</div>
        <div className="countdown-label">seconds</div>
      </div>
      <div className="countdown-text">UNTIL {eventName || "SLAY TIME"}</div>
    </div>
  );
}

export default Countdown;

